import { useEffect, useRef, useState } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
);

export default function Chatbot() {
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role || "Student";

  const chatEndRef = useRef(null);

  const [messages, setMessages] = useState([
    {
      from: "bot",
      type: "text",
      content: `👋 Hello ${user?.name}, I’m your ERP Assistant!`,
    },
  ]);

  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);

  /* ===== AUTO SCROLL ===== */
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, typing]);

  /* ===== BOT LOGIC ===== */
  const getBotResponse = (text) => {
    const msg = text.toLowerCase();

    /* ===== ADMIN CHARTS ===== */
    if (role === "Admin" && msg.includes("analytics")) {
      return {
        type: "chart",
        chartType: "bar",
        title: "University Analytics",
      };
    }

    if (role === "Admin" && msg.includes("attendance")) {
      return {
        type: "chart",
        chartType: "doughnut",
        title: "Attendance Overview",
      };
    }

    /* ===== TEXT RESPONSES ===== */
    if (msg.includes("hello")) return { type: "text", content: "Hello 👋" };
    if (msg.includes("fee")) return { type: "text", content: "💰 Pending Fee: ₹20,000" };
    if (msg.includes("class")) return { type: "text", content: "📘 Next class: DBMS at 10 AM" };

    return { type: "text", content: "🤖 Please ask something relevant." };
  };

  /* ===== SEND MESSAGE ===== */
  const sendMessage = () => {
    if (!input.trim()) return;

    const userMsg = { from: "user", type: "text", content: input };
    setMessages((prev) => [...prev, userMsg]);
    setInput("");
    setTyping(true);

    setTimeout(() => {
      const reply = getBotResponse(input);
      setTyping(false);
      setMessages((prev) => [...prev, { from: "bot", ...reply }]);
    }, 1000);
  };

  /* ===== CHART DATA ===== */
  const barData = {
    labels: ["Students", "Teachers", "Revenue (Cr)"],
    datasets: [
      {
        label: "University Data",
        data: [1200, 80, 1.2],
        backgroundColor: ["#6366f1", "#22c55e", "#f59e0b"],
      },
    ],
  };

  const attendanceData = {
    labels: ["Present", "Absent"],
    datasets: [
      {
        data: [92, 8],
        backgroundColor: ["#22c55e", "#ef4444"],
      },
    ],
  };

  return (
    <div className="chat-page">
      <div className="whatsapp-card">
        <div className="chat-header">
          🤖 ERP Chatbot <span>{role}</span>
        </div>

        <div className="chat-body">
          {messages.map((msg, i) => (
            <div key={i} className={`bubble ${msg.from}`}>
              {msg.type === "text" && msg.content}

              {msg.type === "chart" && msg.chartType === "bar" && (
                <div className="chart-box">
                  <strong>{msg.title}</strong>
                  <Bar data={barData} />
                </div>
              )}

              {msg.type === "chart" && msg.chartType === "doughnut" && (
                <div className="chart-box">
                  <strong>{msg.title}</strong>
                  <Doughnut data={attendanceData} />
                </div>
              )}
            </div>
          ))}

          {typing && (
            <div className="bubble bot typing">
              <span></span><span></span><span></span>
            </div>
          )}

          <div ref={chatEndRef}></div>
        </div>

        <div className="chat-input">
          <input
            placeholder="Type a message…"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <button onClick={sendMessage}>➤</button>
        </div>
      </div>
    </div>
  );
}
